/* One-link pet update. Reached from an email as /pages/pet?id=<petId>&t=<token>.

   The token is validated server-side on every call — nothing here is trusted, and the id
   and token are simply passed through. It authorises that one pet for read and edit only,
   so this page cannot list other pets, create, or delete.

   Query params are read from location.search rather than Liquid: content_for_header caches
   awkwardly on a page like this, and there's no server-side decision to make anyway. */
(function (w, d) {
  'use strict';

  function qp(name) {
    try { return new URLSearchParams(w.location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  d.addEventListener('DOMContentLoaded', function () {
    var root = d.querySelector('[data-petup]');
    if (!root) return;

    var endpoint = root.dataset.endpoint;
    var id = qp('id');
    var token = qp('t');

    var loadingEl = root.querySelector('[data-petup-loading]');
    var invalidEl = root.querySelector('[data-petup-invalid]');
    var doneEl = root.querySelector('[data-petup-done]');
    var doneTitle = root.querySelector('[data-petup-donetitle]');
    var formEl = root.querySelector('[data-petup-form]');
    var errEl = root.querySelector('[data-petup-error]');
    var titleEl = root.querySelector('[data-petup-title]');
    var photoEl = root.querySelector('[data-petup-photo]');
    var photoPick = root.querySelector('[data-petup-photopick]');

    var pendingPhoto = null;

    function show(el) {
      [loadingEl, invalidEl, doneEl, formEl].forEach(function (x) { if (x) x.hidden = x !== el; });
    }
    function fail(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }
    function url(path) {
      return endpoint + (path || '') + '?t=' + encodeURIComponent(token);
    }
    function setPhoto(src) {
      if (!photoEl) return;
      photoEl.style.backgroundImage = src ? 'url("' + src + '")' : '';
      photoEl.classList.toggle('has-img', !!src);
      if (photoPick) photoPick.textContent = src ? 'Change photo' : 'Add a photo';
    }

    if (!id || !token) { show(invalidEl); return; }

    // Load the pet. Any failure — bad token, expired, wrong id — lands on the same message;
    // we never reveal which, so the link can't be used to probe for valid ids.
    fetch(url('/' + encodeURIComponent(id)), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.pet) { show(invalidEl); return; }
        var p = data.pet;
        formEl.name.value = p.name || '';
        formEl.weight_lb.value = p.weight_lb != null ? p.weight_lb : '';
        formEl.breed.value = p.breed || '';
        formEl.birthdate.value = (p.birthdate || '').slice(0, 7);
        if (titleEl && p.name) titleEl.textContent = 'Keep ' + p.name + "'s plan accurate";
        if (doneTitle && p.name) doneTitle.textContent = 'Saved — thanks for updating ' + p.name;
        show(formEl);
        if (p.photo_path) {
          fetch(url('/' + encodeURIComponent(id) + '/photo'), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (r) { if (r && r.url) setPhoto(r.url); })
            .catch(function () {});
        }
      })
      .catch(function () { show(invalidEl); });

    if (photoPick) {
      photoPick.addEventListener('click', function () {
        // capture="environment" opens the rear camera on phones.
        var picker = d.createElement('input');
        picker.type = 'file';
        picker.accept = 'image/jpeg,image/png,image/webp';
        picker.setAttribute('capture', 'environment');
        picker.addEventListener('change', function () {
          var file = picker.files && picker.files[0];
          if (!file) return;
          if (file.size > 5 * 1024 * 1024) { fail('That image is over 5 MB — please pick a smaller one.'); return; }
          pendingPhoto = file;
          setPhoto(URL.createObjectURL(file));
          fail('');
        });
        picker.click();
      });
    }

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = formEl.querySelector('[type="submit"]');
      btn.disabled = true;
      fail('');

      var body = {
        name: formEl.name.value,
        weight_lb: formEl.weight_lb.value === '' ? null : formEl.weight_lb.value,
        breed: formEl.breed.value,
        birthdate: formEl.birthdate.value ? formEl.birthdate.value.slice(0, 7) + '-01' : ''
      };

      var uploadFirst = pendingPhoto
        ? fetch(url('/' + encodeURIComponent(id) + '/photo'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ contentType: pendingPhoto.type, size: pendingPhoto.size })
          })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (sig) {
            if (!sig || !sig.uploadUrl) return null;
            return fetch(sig.uploadUrl, { method: 'PUT', headers: { 'Content-Type': pendingPhoto.type }, body: pendingPhoto })
              .then(function (up) { return up.ok ? sig.path : null; });
          })
          .catch(function () { return null; })
        : Promise.resolve(null);

      uploadFirst.then(function (path) {
        if (path) body.photo_path = path;
        return fetch(url('/' + encodeURIComponent(id)), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.error || 'Could not save. Please try again.');
          show(doneEl);
        });
      }).catch(function (err) {
        fail(err.message);
        btn.disabled = false;
      });
    });
  });
})(window, document);
